import React, {PropTypes} from 'react';
import {Panel, Row, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import {fetchArticleVersions} from './../actions';
import Link from '../../routing/components/Link';
import {FormattedMessage} from 'react-intl';

class ArticleLanguageContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.props.dispatch(fetchArticleVersions(this.props.params.articleId, 'language'));
  }

  render() {
    let {article, params, location, children} = this.props;
    let list = [article.item.attributes.content];

    let elements = [];
    while (list.length > 0) {
      let element = list.shift();
      if (element) {
        elements.push(element);
        list = element.children.concat(list);
      }
    }

    let url = params.langVersion ?
      <small className="pull-right"><Link url={location.pathname.replace(/\/[nlfrde]{2}$/, '/index')}><FormattedMessage id="indexBack"/></Link>
      </small> : '';
    let otherLang = params.langVersion ? <FormattedMessage id={params.langVersion}/> : <FormattedMessage id="differentLanguages"/>;
    let andereTaal = (
      <span>
        {otherLang}{url}
      </span>
    );

    return (
      <Row>
        <Col sm={6}>
          <Panel header={<span><FormattedMessage id="currentLanguage"/></span>} className="panel-clean">
            {elements.map(element =>
              <div key={element.id} style={{marginBottom: 16}} dangerouslySetInnerHTML={{__html: element.body}}/>
            )}
          </Panel>
        </Col>
        <Col sm={6}>
          <Panel header={andereTaal} className="panel-clean">
            {children}
          </Panel>
        </Col>
      </Row>
    );
  }
}

ArticleLanguageContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  article: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  children: PropTypes.node
};


function mapStateToProps(state) {
  const {article, intl} = state;
  return {
    article,
    intl
  };
}

export default connect(mapStateToProps)(ArticleLanguageContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/articles/components/ArticleLanguageContainer.js
 **/